module.exports = __webpack_public_path__ + "img/home4.f2784108.jpg";